
import { Component, Vue, Prop } from 'vue-property-decorator'
import { clientsModule, commonModule, installationsModule } from '@/store/modules/store-accessor'
import InstallationsApi from '@/api/installation-api'
import { formatAmount } from '@/helpers/data'

@Component
export default class DeleteInstallationModal extends Vue {
  @Prop()
  payload!: any;

  isDeletingInstallation = false;
  previewLoading = false;
  preview: DeletePreviewDto | null = null;

  money(amount: number) {
    return formatAmount(amount);
  }

  get returnedClients() {
    if (!this.preview) return [];
    const byId = new Map<number, DeletePreviewClientDto>();
    [...this.preview.credit.clients, ...this.preview.cash.clients].forEach((client) => {
      const existing = byId.get(client.client_id);
      if (existing) {
        existing.amount = Number(existing.amount) + Number(client.amount);
      } else {
        byId.set(client.client_id, { ...client, amount: Number(client.amount) });
      }
    });
    return Array.from(byId.values());
  }

  get paymentsReturnedMessage() {
    if (!this.preview) return '';
    const amount = this.money(this.preview.payments.total);
    const clients = this.returnedClients;
    if (clients.length === 1) {
      const key = this.preview.payments.count === 1
        ? 'deleteInstallationPaymentReturnedToClient'
        : 'deleteInstallationPaymentsReturnedToClient';
      return this.$t(key, {
        amount,
        client: clients[0].name || this.$t('client'),
      });
    }
    return this.$t('deleteInstallationPaymentsReturnedToCredit', { amount });
  }

  countedLine(count: number, singular: string, plural: string, total?: number) {
    const label = `${count} ${this.$t(count === 1 ? singular : plural)}`;
    if (total === undefined) return label;
    return `${label}, ${this.money(total)} €`;
  }

  creditLine(client: DeletePreviewClientDto) {
    return this.$t('deletePaymentCreditForClient', {
      amount: this.money(client.amount),
      client: client.name || this.$t('client'),
    });
  }

  async mounted() {
    commonModule.initSnackbar({});
    this.previewLoading = true;
    try {
      this.preview = await new InstallationsApi().getInstallationDeletePreview(this.payload.installation.id);
    } finally {
      this.previewLoading = false;
    }
  }

  async hideModal () {
    commonModule.hideModal();
  }

  async hideSideView() {
    commonModule.hideSideview();
  }

  async doDeleteInstallation () {
    this.isDeletingInstallation = true;
    try {
      await installationsModule.deleteInstallation(this.payload.installation);
      await this.refreshOpenClient();
      this.hideModal();
      this.hideSideView();
    } finally {
      this.isDeletingInstallation = false;
    }
  }

  async refreshOpenClient() {
    const openClientId = (clientsModule.currentClient as any)?.info?.id;
    if (!openClientId) return;
    await Promise.all([
      clientsModule.getClientsInfo(String(openClientId)),
      clientsModule.loadCurrentClientCredit(String(openClientId)),
    ]).catch(() => undefined);
  }
};
